import LegalPage from './index'
import styles from './style.module.scss'

/* Inhaltlich massgeblich: Junior/rechtstexte/barrierefreiheitserklaerung.md (Stand August 2026). */
export default function Barrierefreiheit() {
	return (
		<LegalPage title="Erklärung zur Barrierefreiheit" stand="August 2026">
			<p>
				Junior Achievement Austria ist bemüht, die Plattform „Junior Datenbank" (
				<a href="https://company.junior.cc">company.junior.cc</a>) im Einklang mit den geltenden Vorgaben zur
				Barrierefreiheit — insbesondere den Web Content Accessibility Guidelines (WCAG) 2.1,
				Konformitätsstufe AA, und der europäischen Norm EN 301 549 — zugänglich zu machen.
			</p>
			<p>
				Diese Erklärung zur Barrierefreiheit gilt für die Webanwendung „Junior Datenbank" unter{' '}
				<a href="https://company.junior.cc">company.junior.cc</a>.
			</p>

			<h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
			<p>
				Diese Website ist mit den WCAG 2.1, Konformitätsstufe AA, <strong>teilweise vereinbar</strong>. Die
				nachstehend aufgeführten Inhalte sind derzeit nicht oder nicht vollständig barrierefrei.
			</p>

			<h2>Nicht barrierefreie Inhalte</h2>
			<p>Die folgenden Einschränkungen sind uns bekannt:</p>
			<ol>
				<li>
					<strong>Namen, Rollen und Werte interaktiver Elemente:</strong> Nicht alle interaktiven
					Bedienelemente (z. B. Symbol-Schaltflächen, Auswahlfelder, Dialoge, sortierbare Tabellen) verfügen
					durchgehend über vollständige ARIA-Auszeichnungen und programmatisch ermittelbare Namen (WCAG
					1.3.1, 4.1.2). Die Auszeichnungen werden schrittweise ergänzt.
				</li>
				<li>
					<strong>Komplexe Interaktionen:</strong> Einzelne Funktionen — etwa das Verschieben von Elementen
					per Drag-and-drop und das Zuschneiden von Bildern — sind derzeit nicht vollständig mit der Tastatur
					bedienbar (WCAG 2.1.1). Für zentrale Aufgaben stehen alternative Wege über Formulare bzw. die
					Programmadministration zur Verfügung.
				</li>
				<li>
					<strong>PDF-Dokumente:</strong> Ein Teil der auf der Plattform bereitgestellten PDF-Dokumente
					(z. B. Handbücher, Infoblätter, Urkunden, ältere Formulare) ist nicht vollständig barrierefrei,
					insbesondere nicht durchgängig mit Tags und Alternativtexten versehen (WCAG 1.1.1, 1.3.1). Bei
					Bedarf stellen wir die Inhalte auf Anfrage in einer zugänglichen Form zur Verfügung — wenden Sie
					sich dazu an <a href="mailto:info@junior.cc">info@junior.cc</a>.
				</li>
				<li>
					<strong>Kontraste und visuelle Gestaltung:</strong> Die Farbkontraste einzelner Bedien- und
					Statuselemente wurden noch nicht vollständig gegen WCAG 1.4.3/1.4.11 geprüft.
				</li>
				<li>
					<strong>Sprachfassungen:</strong> Die Plattform ist zweisprachig (Deutsch/Englisch) angelegt;
					einzelne Bereiche (z. B. das Administrations-Handbuch und die Rechtstexte) stehen nur auf Deutsch
					zur Verfügung.
				</li>
			</ol>
			<p>
				Wir arbeiten laufend daran, die festgestellten Mängel zu beheben und die Barrierefreiheit der Plattform
				zu verbessern.
			</p>

			<h2>Erstellung dieser Erklärung</h2>
			<p>
				Diese Erklärung wurde am 31. Juli 2026 erstellt. Grundlage ist eine Selbstbewertung der Plattform durch
				den Betreiber und den technischen Dienstleister (DaVinciLab GmbH); eine externe Prüfung durch Dritte
				hat bisher nicht stattgefunden. Die Erklärung wird bei wesentlichen Änderungen der Plattform,
				jedenfalls aber einmal jährlich, überprüft.
			</p>

			<h2>Feedback und Kontakt</h2>
			<p>
				Sind Ihnen Barrieren aufgefallen, die hier nicht angeführt sind? Können Sie Inhalte der Plattform nicht
				oder nur eingeschränkt nutzen? Wir freuen uns über Ihre Rückmeldung:
			</p>
			<address className={styles.address}>
				<strong>Junior Achievement Austria</strong>
				<br />
				Heinrichsgasse 3/1/Top 8+9, 1010 Wien
				<br />
				Telefon: <a href="tel:+4367684171755">+43 676 841 717 55</a> · E-Mail:{' '}
				<a href="mailto:info@junior.cc">info@junior.cc</a>
			</address>
			<p>
				Bitte beschreiben Sie das Problem und geben Sie die Adresse (URL) der betroffenen Seite an. Wir bemühen
				uns, Anfragen rasch zu beantworten und Barrieren zeitnah zu beseitigen; auf Wunsch stellen wir
				Informationen in einer für Sie zugänglichen Form bereit.
			</p>

			<h2>Durchsetzungsverfahren</h2>
			<p>
				Sollten Sie auf Ihre Mitteilung keine zufriedenstellende Antwort erhalten, können Sie sich im Rahmen
				des Bundes-Behindertengleichstellungsgesetzes (BGStG) an das Sozialministeriumservice (Bundesamt für
				Soziales und Behindertenwesen) wenden und ein Schlichtungsverfahren anregen:
			</p>
			<address className={styles.address}>
				<strong>Sozialministeriumservice</strong>
				<br />
				Babenbergerstraße 5, 1010 Wien
				<br />
				Web:{' '}
				<a href="https://www.sozialministeriumservice.at" target="_blank" rel="noopener noreferrer">
					www.sozialministeriumservice.at
				</a>
			</address>
		</LegalPage>
	)
}
